<template>
  <div class="contain">
    <!-- 订单状态 -->
    <van-sticky>
      <van-tabs @click="getState" v-model="status">
        <van-tab
          v-for="(item, index) in tabList"
          :title="item.name"
          :key="index"
        >
        </van-tab>
      </van-tabs>
    </van-sticky>
    <!-- 订单列表 -->
    <div class="box">
      <van-list
        v-model="loading"
        offset="10"
        :finished="finished"
        finished-text="没有更多了 ~"
        @load="onLoad"
        :immediate-check="false"
      >
        <div v-for="(item, index) in List" :key="index">
          <van-card
            v-for="(j, k) in item.detail"
            :key="k"
            :num="j.buyNumber"
            :price="j.buyIntegral + '积分'"
            :title="j.goodsName"
            :thumb="j.goodsImg.split(',')[0]"
            :desc="item.remark"
          >
            <template #tags>
              <van-tag type="primary" v-if="item.status == 1">已下单</van-tag>
              <van-tag type="warning" v-if="item.status == 2">待取货</van-tag>
              <van-tag type="success" v-if="item.status == 3">已完成</van-tag>
              <van-tag type="danger" v-if="item.status == 4">已取消</van-tag>
            </template>
            <template #footer>
              <van-button
                size="small"
                @click="cancel(item)"
                v-if="userType == item.userId && item.status == 1"
                >取消订单</van-button
              >
              <van-button
                size="small"
                type="info"
                v-if="storeType == item.storeId && item.status == 1"
                @click="receive(item.id)"
                >接单</van-button
              >
              <van-button
                type="warning"
                size="small"
                v-if="userType == item.userId && item.status == 2"
                @click="pickUp(item)"
                >取货</van-button
              >
              <van-button
                type="primary"
                size="small"
                v-if="
                  userType == item.userId &&
                  item.status == 3 &&
                  item.isComment == 0
                "
                @click="evaluate(item)"
                >评价</van-button
              >
            </template>
          </van-card>
        </div>
      </van-list>
      <div class="fixed">
        <button class="bottomBtn" @click="evaluateList">我的评价</button>
      </div>
      <!-- 空状态 -->
      <!-- <van-empty v-if="List.length == 0" description="暂无数据" /> -->
    </div>
  </div>
</template>

<script>
import { getOrderList, updateOrder } from "@/api/Hotel";
import { getOpenId, getPlatform, getStoreId, getUrl } from "@/utils/auth";
import { Toast, Dialog } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      tabList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "已下单",
        },
        {
          id: 2,
          name: "待取货",
        },
        {
          id: 3,
          name: "已完成",
        },
        {
          id: 4,
          name: "已取消",
        },
      ],
      status: 0,
      List: [],
      storeType: "",
      page: 1,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.page = this.page + 1;
      this.getOrderList(undefined);
    },
    getState(name, tab) {
      console.log(name, tab);
      this.List = [];
      this.page = 1;
      this.status = name;
      this.getOrderList();
    },
    // 获取订单列表
    getOrderList() {
      getOrderList({
        userId: getOpenId(),
        status: this.status,
        pageSize: 10,
        pageNum: this.page,
        platformId: getPlatform(),
        storeId: getStoreId(),
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.List = this.List.concat(rows);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },

    // 取消订单
    cancel(item) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定要取消该订单吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: item.id, status: 4 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              this.addUserIntegral(item.totalMoney);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 取货
    pickUp(item) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确认已收到货了吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: item.id, status: 3 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              this.updUserIntegral(item);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/gotoJF?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 评价
    evaluate(item) {
      console.log(item);
      this.gotoUrl(
        "/hotels/evaluate/" + item.id + "/" + item.detail[0].goodsId
      );
    },

    // 我的评价 列表
    evaluateList() {
      this.gotoUrl("/hotels/evaluateList/1");
    },
    // 修改对应项目 积分
    updUserIntegral(item) {
      console.log(item.totalMoney, "totalMoney");
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/updStoreIntegral";
      const params = { storeId: item.storeId, integral: item.totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          Toast.success("取货成功");
          this.List = [];
          that.getOrderList();
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },

    // 修改对应项目 积分
    addUserIntegral(totalMoney) {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/addUserIntegral";
      const params = { userId: getOpenId(), integral: totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          Toast.success("取消成功");
          this.List = [];
          that.getOrderList();
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    // 接单
    receive(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定要接收该订单吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: id, status: 2 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              Toast.success("接单成功");
              this.List = [];
              this.getOrderList();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  created() {
    this.getOrderList();
    this.storeType = getStoreId();
    this.userType = getOpenId();
  },
  mounted() {},
};
</script> 

<style scoped>
.contain {
  background: #f6f6f6;
  min-height: 100vh;
}
/deep/ .van-tabs__nav {
  background: #f6f6f6;
}
/deep/ .van-tab {
  font-size: 14px;
  font-family: PingFang SC;
}

/deep/ .van-tabs__line {
  border-radius: 3px !important;
  background-color: #f4bf41;
}

.box {
  padding: 10px 10px;
}

/deep/ .van-card {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}

/deep/ .van-card__price-currency {
  display: none;
}

/deep/ .van-card__content {
  padding: 6px 0 0;
  box-sizing: border-box;
}

/deep/ .van-card__title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: normal;
}

/deep/ .van-card__price {
  color: #ffffff;
}

/deep/ .van-card__price-integer {
  color: #232323;
  font-size: 15px;
  font-family: PingFang SC;
}

/deep/ .van-card__desc {
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  max-height: 100px;
  white-space: normal;
}

/deep/ .van-button {
  border-radius: 8px;
  width: 66px;
  /* padding: 0 16px; */
}

/deep/ .van-list {
  padding-bottom: 100px;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.08);
  z-index: 100;
  text-align: center;
}

.bottomBtn {
  background: #f4bf41;
  border-radius: 22px;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  width: 94%;
  padding: 11.5px 0;
  margin-top: 7.5px;
}

/deep/ .van-tag {
  position: absolute;
  right: -16px;
  top: -8px;
  padding: 0px 4px;
  font-size: 8px;
  border-radius: 0 8px 0 8px;
}
</style>